import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { DealsSummarySection } from "../shared/DealsSummarySection";

export function ManagerTeamPerformanceTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = () => {
      api.get("/manager/team-performance")
        .then(({ data }) => setRows(data))
        .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)))
        .finally(() => setLoading(false));
    };
    fetchData();
    const interval = setInterval(fetchData, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div data-testid="manager-performance-tab">
      <h2 className="font-serif text-xl text-igc-cream tracking-tight mb-1" title="A side-by-side comparison of every rep on your team, so you can spot who's thriving and who might need a check-in.">Team Performance</h2>
      <p className="text-igc-muted text-xs mb-4">Real-time activity for every rep on your team — updates automatically.</p>
      {loading ? (
        <p className="text-igc-muted text-sm" data-testid="manager-performance-loading">Loading...</p>
      ) : rows.length === 0 ? (
        <p className="text-igc-muted text-sm" data-testid="manager-performance-empty">No affiliates on your team yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="manager-performance-table">
            <thead>
              <tr className="text-igc-muted text-xs uppercase tracking-widest text-left border-b border-igc-gold/15">
                <th className="py-2 pr-4" title="The rep's name and rep code.">Rep</th>
                <th className="py-2 pr-4" title="The total number of leads currently assigned to this rep, across every stage.">Leads Assigned</th>
                <th className="py-2 pr-4" title="How many of this rep's leads have moved past 'New' — meaning the rep has logged at least one disposition (call result) on them.">Contacted</th>
                <th className="py-2 pr-4" title="Deals this rep has submitted that are still being worked through underwriting or review — not yet won or lost.">In Progress</th>
                <th className="py-2 pr-4" title="Deals this rep has successfully closed and gotten credit for.">Won</th>
                <th className="py-2 pr-4" title="Total commission this rep has earned from approved deals, all time.">Commission Earned</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.affiliate_id} className="border-b border-igc-gold/10" data-testid={`manager-performance-row-${r.affiliate_id}`}>
                  <td className="py-2.5 pr-4 text-igc-cream">{r.display_name} <span className="text-igc-muted text-xs">({r.affiliate_code})</span></td>
                  <td className="py-2.5 pr-4 text-igc-cream">{r.leads_assigned}</td>
                  <td className="py-2.5 pr-4 text-igc-cream">{r.leads_contacted}</td>
                  <td className="py-2.5 pr-4 text-igc-goldText">{r.deals_in_progress}</td>
                  <td className="py-2.5 pr-4 text-igc-success">{r.deals_won}</td>
                  <td className="py-2.5 pr-4 text-igc-success">${r.commission_earned.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <DealsSummarySection apiBase="/manager" />
    </div>
  );
}
